<template>
  <el-drawer :title="title" :before-close="close" :visible.sync="drawerVisible" @opened="drawOpen" direction="rtl"
    :wrapperClosable='false' class="demo-drawer" ref="drawer">
    <div class="demo-drawer__content">
      <el-form ref="form" :model="form" :label-width="formLabelWidth" v-loading="loading" element-loading-text="加载中..."
        class="d2-mr-20 formbirth" size="small">
        <el-form-item label="主题内容" prop="Subject" :rules="[{ required: true, message: '主题内容不能为空', trigger: 'blur' }]">
          <el-input v-model="form.Subject" type="textarea" rows='9' autocomplete="off" placeholder="请输入主题内容"
            maxlength="200" show-word-limit>
          </el-input>
        </el-form-item>
        <el-form-item label="类型" prop="Category" :rules="[{required: true, message: '类型不能为空', trigger: 'blur'}]">
          <el-select v-model="form.Category" placeholder="请选择类型" class="w100">
            <el-option v-for="val in typeOption" :label="val.Name" :value="val.Name" :key="val.Name">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="解决方案" prop="Content"
          :rules="[{ required: true, message: '解决方案不能为空', trigger: 'blur' },{ min: 30, message: '解决方案的字数不能少于30字', trigger: 'blur' }]">
          <el-input v-model="form.Content" type="textarea" rows='16' autocomplete="off" placeholder="请输入解决方案"
            maxlength="500" show-word-limit>
          </el-input>
        </el-form-item>
        <el-form-item label="素材">
          <el-upload ref="upload" class="avatar-uploader" action="#" accept=".jpeg,.png,.jpg,.gif"
            :before-upload="beforeAvatarUpload" :http-request="uploadFile" :before-remove="beforeRemove"
            :on-remove="handleRemove" :limit="9" :file-list="fileList" list-type="picture-card"
            :on-exceed="handleExceed">
            <i class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
      </el-form>
      <div class="demo-drawer__footer">
        <el-button size="small" type="primary" @click="submitHandle" :loading="loading" :disabled="disable">
          {{ loading ? "提交中 ..." : "确 定" }}</el-button>
        <el-button size="small" @click="close">取 消</el-button>
      </div>
    </div>
  </el-drawer>
</template>
<script>
  import * as indexService from "@/api/sys/index";
  import rules from "@/libs/rules";
  const defualtForm = {
    Subject: '',
    Category: '',
    Content: '',
    Materials: '',
  };
  export default {
    name: "editPublish",
    props: {
      publish: Object,
      value: Boolean,
    },
    data() {
      return {
        loading: false,
        drawerVisible: false,
        disable: false,
        rulesUtils: rules,
        form: Object.assign({}, defualtForm),
        fileIds: [], //文件id
        index: 0,
        fileList: [],
        filetypes: [
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
          "application/msword",
        ], //文件属性
        typeOption: [],
        formLabelWidth: "100px",
        title: ''
      };
    },
    watch: {
      value(val) {
        this.drawerVisible = val;
      },
      drawerVisible(val) {
        this.$emit("input", val);
      },
    },
    computed: {
      unitname() {
        return this.$store.state.d2admin.userInfo.userinfo;
      },
    },
    methods: {
      drawOpen() {
        this.$refs.form.resetFields();
        if (this.publish.ID) {
          Object.keys(this.publish).forEach(v => {
            if (v == 'Materials' && this.publish[v] != '') {
              let Materials = this.publish[v].split(',')
              if (Materials.length != 0) {
                this.fileIds = Materials;
                this.fileList = this.fileIds.map(b => {
                  let arr = v.split('/')
                  let len = arr.length
                  return {
                    url: b.indexOf('http') != -1 ? b : this.$apiUrl + '' + b,
                    name: arr[len - 1],
                  }
                });
              }
            }
            this.form[v] = this.publish[v]
          })
          this.title = '修改热点'
        } else {
          this.form = Object.assign({}, defualtForm);
          this.title = '发布热点'
        }
        indexService.GetIsMember().then((data) => {
          if (data.data.isMember == false) {
            this.$message.warning("此账号不是会员,无法申请");
            setTimeout(() => {
              this.drawerVisible = false;
            }, 2000);
          } else {
            this.GetDiseaseType();
          }
        });
      },
      GetDiseaseType() {
        let query = {
          limit: 999,
          shortTitle: "热点分类视图",
          start: 1,
        };
        indexService.GetDiseaseType(query).then((data) => {
          this.typeOption = data.data
        });
      },
      submitHandle() {
        this.$refs["form"].validate((valid) => {
          if (valid) {
            this.loading = true;
            let form = {
              childrenData: [],
              shortTitle: "职代会热点",
              mainData: {
                Subject: this.form.Subject,
                Category: this.form.Category,
                Content: this.form.Content,
                Materials: this.form.Materials,
                City: this.unitname.uInfo.City,
                Depart: this.unitname.uInfo.Depart,
                Email: this.unitname.uInfo.Email,
                GroupName: this.unitname.uInfo.GroupName,
                JoinMemberDay: this.unitname.uInfo.JoinMemberDay,
                Mobile: this.unitname.uInfo.Mobile,
                MemberCode: this.unitname.uInfo.Code,
                MemberName: this.unitname.uInfo.Name,
                StationName: this.unitname.uInfo.Substation,
                Substation: this.unitname.uInfo.Substation,
                WorkUnit: this.unitname.uInfo.WorkUnit,
                avatarUrl: '',
              },
            };
            if (this.publish.ID) {
              form = {
                ...form,
                dataId: this.publish.ID,
              }
            } else {
              form = {
                ...form,
                dataId: 0,
              }
            }

            indexService
              .addQuestionData({
                ...form,
              })
              .then((data) => {
                this.$message.success(this.publish.ID ? "修改成功！" : "发布成功！");
                this.drawerVisible = false;
                this.$emit("submit");
                this.close();
              })
              .catch((e) => {
                this.loading = false;
              });
          } else {
            return false;
          }
        });
      },
      //上传图片
      beforeAvatarUpload(file) {
        let isLt2M = file.size < 1024 * 5120;
        let isJPG = ["image/jpeg", "image/png", "image/jpg","image/gif"].includes(file.type);

        if (!isJPG) {
          this.$message.error("上传图片只能是 JPG/PNG/JPEG/GIF 格式!");
        }
        if (!isLt2M) {
          this.$message.error("上传图片大小不能超过 5MB!");
        }
        return isJPG && isLt2M;
      },
      handleExceed() {
        this.$message.warning("只能上传9个");
      },
      beforeRemove(file) {
        let fileList = this.$refs["upload"].uploadFiles;
        let index = fileList.findIndex((fileItem) => {
          return fileItem.uid === file.uid;
        });
        this.index = index;
        // 本人只能删除本人的文件
        if (file.Creator && util.cookies.get("uuid") != file.Creator) {
          this.$message.warning("只能删除自己上传的文件");
          return false;
        }
        return true;
      },
      handleRemove(file, fileList) {
        if (this.fileIds) {
          this.fileIds.forEach((v, i) => {
            if (this.index == i) {
              this.fileIds.splice(i, 1);
              this.fileList.splice(i, 1);
              this.form.Materials = this.fileIds.toString();
            }
          });
        }
      },
      //上传图片
      uploadFile(item) {
        let _this = this;
        let formdata = new FormData();
        formdata.append("image", item.file);
        indexService
          .uploadFileNo(formdata, item.file.name)
          .then((data) => {
            this.$message({
              type: "success",
              message: "图片上传成功!",
            });
            item.onSuccess();
            let filepath = data.data.filepath
            if (filepath.indexOf('http') == -1) filepath = this.$apiUrl + filepath

            this.fileIds.push(filepath);
            this.fileList.push({
              name: data.data.filename,
              url: filepath,
            });
            this.form.Materials = this.fileIds.toString();
          })
          .catch((error) => {
            item.onError();
          });
      },
      close() {
        this.$refs.form.resetFields();
        this.drawerVisible = false;
        this.fileIds = [];
        this.fileList = [];
        this.loading = false;
      },
    },
  };
</script>
<style scoped>
  .demo-drawer /deep/ .el-drawer__body {
    padding: 20px;
  }
</style>